export default {
  dbi_metric_mobile_cross_usage: '玩家重叠度',
  dbi_metric_mobile_cross_affinity: '玩家亲和度',
};
